import { FragmentDefiner, useReadFragment } from "../../../GlobalHooks/useReadFragment";
import { useEffect, useState } from "react";

import { showFloors } from "../../../Utils/Functions";
import { useFilters } from "../Filters.hook";

export const FRAGMENT_FLOORS_OPTIONS = new FragmentDefiner(
	"Filter",
	`
      id
      name
      options
	`
);
export const FRAGMENT_FLOORS = new FragmentDefiner(
	"Filters",
	`
      floors {
        ${FRAGMENT_FLOORS_OPTIONS.query()}
      }
	`
);
export interface FloorProps {
	labeled?: boolean;
	collapsable?: boolean;
	filterChanged: ({}: any) => void;
}

export const useFloors = () => {
	const { filters } = useFilters();

	const show = showFloors(filters?.property_type_id);

	const type = "multiple";
	return {
		data: {
			value: filters?.floors,
			type
		},
		show,
	};
};
